import axios from 'axios'
export default {
  getCCDesc(cc){
    let response = axios.get('../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=91&cc=' + cc)
    .then((response) => {
      console.log('getCCDESc')
      console.log(response)
    })
    .catch(function (error) {
      console.log(error)
    })
  return response
  },
  getCCbyRegion (region) {
    let response = axios.get('../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=1&region=' + region)
      .then((response) => {
        var a = []
        for (let json in response.data) {
          let item = response.data[json]
          let descWithCode = {
            descWithCode:
              item.lscccode + ' : ' + item.lsccdesc
          }
          let lsccdesc = {
            lsccdesc: item.lsccdesc
          }
          // response.data[json] = Object.assign(descWithCode, item)
          a.push(Object.assign(descWithCode, item))
          // a.push(Object.assign(lsccdesc, item))
        }
        return a
      })
      .catch(function (error) {
        console.log(error)
      })
    return response
  },
  getTTSub (rcode,yymm){
    return new Promise((resolve, reject) => {
      axios.get('../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=614&rcode=' + rcode + '&yymm='+ yymm)
      // axios.get('/api/stat/statcenter/v1/list?action=614&rcode=' + rcode + '&yymm='+ yymm)
        .then(function(response) {
          console.log('response TTsubReturnA')
          console.log(response)
          resolve(response) 
        })
        .catch(function (error) {
          console.log(error)
          reject(error)
        })
      }
    )
    
  
  },
  getTTbyRcode (rcode,yymm,aa){
    return new Promise((resolve, reject) => {
      var listTT = []
      axios.get('../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=616&rcode=' + rcode + '&aa=' + aa + '&yymm=' + yymm)
      // axios.get('/api/stat/statcenter/v1/list?action=616&rcode=' + rcode + '&aa=' + aa + '&yymm=' + yymm)
      .then((response) => {
        console.log("rr", response)
        for (let json in response.data) {
          let item = response.data[json]
          var codeTT = item.lscatmTTcode.toString()
          let descWithCode = {
            descWithCode: codeTT.substring(0,6)  + ' : ' + item.lscatmTTdesc
          }
          listTT.push(Object.assign(descWithCode, item))
        }
        console.log("listTT", listTT)
        resolve(listTT)
      })
      .catch(function (error) {
        reject(error)
      })
    })
  },
  getRcodebyCC (cc) {
    let response = axios.get('../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=2&cc=' + cc)
    // let response = axios.get('/api/stat/statcenter/v1/list?action=2&cc=' + cc)
      .then((response) => {
        var a = []
        for (let json in response.data) {
          let item = response.data[json]
          let descWithCode = {
            descWithCode:
            item.lsrcodecode.substring(0,6) + ' : ' + item.lsrcodedesc
          }
          // response.data[json] = Object.assign(descWithCode, item)
          a.push(Object.assign(descWithCode, item))
        }                
        return a
      })
      .catch(function (error) {
        console.log(error)
      })
    return response
  },
  getMMbyTT (rcode,aa,yymm,tt){
    let response = axios.get('../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=617&rcode=' + rcode + '&aa=' + aa + '&yymm=' + yymm + '&tt=' + tt)
    .then((response) => {
      var a = []
      for (let json in response.data) {
        let item = response.data[json]
        let descWithCode = {
          descWithCode:
          item.lscatmMMcode + ' : ' + item.lscatmMMdesc
        }
        a.push(Object.assign(descWithCode, item))
      }
      return a
    })
    .catch(function (error) {
      console.log(error)
    })
    return response
  },
  
  getRcodeCCAAcodebyCC (yymm,rcode) {
    let response = axios.get('../connectSAPI/stat_forward.php?API=/api/stat/statcenter/v1/list?action=614&yymm=' + yymm + '&rcode='+ rcode)
      .then((response) => {
        console.log('response getRcodebyCC')
        console.log(response)
        var a = []
        for (let json in response.data) {
          let item = response.data[json]
          let descWithCode = {
            descWithCode:
             item.lsrcodecode + ' : ' + item.lsrcodedesc
          }
          // response.data[json] = Object.assign(descWithCode, item)
          a.push(Object.assign(descWithCode, item))
        }
        return a
      })
      .catch(function (error) {
        console.log(error)
      })
    return response
  },
  getCATMDesc (catm) {
    let response = axios.get('../connectSAPI/stat_forward.php?API=/api/tabdb/catm/v1/?code_like=' + catm)
      .then((response) => {
        var a = response
        return a
      })
      .catch(function (error) {
        console.log(error)
      })
    return response
  }
}
